(function () {
  if (customElements.get('gif-pause-toggle')) return;

  class GifPauseToggle extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;

      // Nothing to pause (no gif/video children) — stay a transparent wrapper.
      if (!this.getEligibleMedia().length) return;

      this.pauseLabel = this.getAttribute('pause-label') || 'Pause animation';
      this.playLabel = this.getAttribute('play-label') || 'Play animation';
      this.paused = false;
      this.activeMedia = null;

      const shadow = this.attachShadow({ mode: 'open' });
      shadow.innerHTML = `
        <style>
          :host { position: relative; }
          canvas {
            display: none;
            max-width: 100%;
            width: 100%;
            height: auto;
          }
          canvas.is-active { display: block; }
          button {
            position: absolute;
            top: var(--gpt-btn-top, auto);
            bottom: var(--gpt-btn-bottom, 12px);
            left: var(--gpt-btn-left, auto);
            right: var(--gpt-btn-right, 12px);
            z-index: 2;
            background: var(--gpt-btn-bg, rgba(0, 0, 0, 0.55));
            color: var(--gpt-btn-color, #fff);
            border: none;
            border-radius: var(--gpt-btn-radius, 50%);
            width: var(--gpt-btn-size, 36px);
            height: var(--gpt-btn-size, 36px);
            font-size: 14px;
            line-height: 1;
            cursor: pointer;
          }
        </style>
        <slot></slot>
        <canvas part="canvas" aria-hidden="true"></canvas>
        <button part="button" type="button" aria-label="${this.pauseLabel}">❚❚</button>
      `;

      this.canvas = shadow.querySelector('canvas');
      this.button = shadow.querySelector('button');
      this.button.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggle();
      });
    }

    getEligibleMedia() {
      return Array.from(this.querySelectorAll('img[data-gif], video'));
    }

    getVisibleMedia() {
      return this.getEligibleMedia().find((el) => el.offsetParent !== null) || null;
    }

    toggle() {
      if (this.paused) {
        this.resume();
        return;
      }
      const media = this.getVisibleMedia();
      if (!media) return;
      if (media.tagName === 'VIDEO') {
        this.toggleVideo(media);
      } else {
        this.pauseGif(media);
      }
    }

    toggleVideo(video) {
      if (video.paused) {
        video.play();
        this.button.textContent = '❚❚';
        this.button.setAttribute('aria-label', this.pauseLabel);
      } else {
        video.pause();
        this.button.textContent = '▶';
        this.button.setAttribute('aria-label', this.playLabel);
      }
    }

    pauseGif(img) {
      this.activeMedia = img;
      this.canvas.width = img.naturalWidth || img.offsetWidth;
      this.canvas.height = img.naturalHeight || img.offsetHeight;
      this.canvas.getContext('2d').drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
      this.canvas.classList.add('is-active');
      img.style.visibility = 'hidden';
      this.button.textContent = '▶';
      this.button.setAttribute('aria-label', this.playLabel);
      this.paused = true;
    }

    resume() {
      const media = this.activeMedia;
      if (media) {
        media.src = media.getAttribute('src').split('?')[0] + '?t=' + Date.now();
        media.style.visibility = '';
      }
      this.canvas.classList.remove('is-active');
      this.button.textContent = '❚❚';
      this.button.setAttribute('aria-label', this.pauseLabel);
      this.paused = false;
      this.activeMedia = null;
    }
  }

  customElements.define('gif-pause-toggle', GifPauseToggle);
})();
